const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user editor directive to manage edits on user objects
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('addGroupManager', ['Authorization', 'Groups', function(Authorization, Groups) {
  return {
    restrict: 'E',
    scope: {
      user: '=',
      new: '@?'
    },
    replace: true,
    template: require('../../../templates/directives/manager/add-group-manager.html'),
    controller: ['$scope', function($scope) {
      var self = this;
      self.user = Authorization.getAuthToken() && Authorization.getAuthToken().user;
      var managing_groups = self.user.managing_groups || [];

      // save original state

      // display managing groups - not editable
      self.info = {
        loading: false,
        originalManager: false,
        optionIds: [],
        options: [],
        alreadyManagingIds: [],
        alreadyManaging: [],
        selections: []
      };

      $scope.$watch('addManager.info.selections', function(newVal, oldVal) {
      // If added to group as manager
        // Also set is_manager to true
        if (!self.info.selections || !self.info.selections.length) {
          if (!self.info.originalManager) {
            $scope.user.is_manager = false;
          }
        }

        if (self.info.selections.length) {
          $scope.user.is_manager = true;
        }

        $scope.user.managing_groups = self.info.alreadyManagingIds.concat(self.info.selections);
      });


      self.initialize = function() {
        self.loading = true;
        self.info.originalManager = $scope.user.is_manager || false;
        // Find groups the user is currently managing
        self.info.alreadyManagingIds = $scope.user && $scope.user.managing_groups || [];
        // find groups the manager manages that the user isn't already managing
        managing_groups.forEach(function(group) {
          if (self.info.alreadyManagingIds.indexOf(group) === -1) {
            self.info.optionIds.push(group);
          }
        });

        var totalToFind = [].concat(self.info.alreadyManagingIds, self.info.optionIds);
        Groups.find({fields: 'name,_id', _id: '$in,' + totalToFind.length + ',' + totalToFind.join(',')}).$promise
        .then(function(results) {
          results.forEach(function(group) {
            group.value = group._id;
            if (self.info.alreadyManagingIds.indexOf(group._id) !== -1) {
              self.info.alreadyManaging.push(group);
            }
            if (self.info.optionIds.indexOf(group._id) !== -1) {
              self.info.options.push(group);
            }
          });

          self.info.loading = false;
        }).catch(function(error) {
          console.log('error', error);
        });
      };

      if ($scope.user && ($scope.user._id || $scope.new)) {
        self.initialize();
        return;
      }

      var userWatch = $scope.$watch('user', function(newVal, oldVal) {
        if (newVal && newVal._id) {
          self.initialize();
          userWatch();
        }
      });

    }],
    controllerAs: 'addManager'
  };
}]);